import React from 'react';
export const PromoBanner = () => {
  return <section className="w-full bg-gradient-ring py-12 px-6 text-center relative overflow-hidden" data-id="element-129">
      {/* Decorative overlay */}
      <div className="absolute inset-0 bg-white/10 mix-blend-overlay" data-id="element-130"></div>

      <div className="relative z-10 max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-131">
        <div className="text-left" data-id="element-132">
          <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-2" data-id="element-133">
            ¿Buscás las mejores promos? 👀
          </h3>
          <p className="text-white/90 text-lg" data-id="element-134">
            Seguinos en Instagram y no te pierdas nada
          </p>
        </div>

        <a href="#" className="whitespace-nowrap bg-white text-brand-magenta px-8 py-4 rounded-full font-bold hover:scale-105 transition-transform shadow-lg" data-id="element-135">
          Ver promociones
        </a>
      </div>
    </section>;
};